export interface StreamScheduleEntry {
  dayKey: string;
  time: string;
  type: string;
  active: boolean;
}

export const streamSchedule: StreamScheduleEntry[] = [
  { dayKey: 'Lundi', time: 'OFF', type: '-', active: false },
  { dayKey: 'Mardi', time: 'OFF', type: '-', active: false },
  { dayKey: 'Mercredi', time: 'OFF', type: '-', active: false },
  { dayKey: 'Jeudi', time: 'OFF', type: '-', active: false },
  { dayKey: 'Vendredi', time: 'OFF', type: '-', active: false },
  { dayKey: 'Samedi', time: 'OFF', type: '-', active: false },
  { dayKey: 'Dimanche', time: 'OFF', type: '-', active: false },
];
